import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/LoginS.vue'
import MapPage from '@/views/MapS.vue'
import { useAuth } from '@/composables/useAuth'

const routes = [
  { path: '/', redirect: '/map' },
  { path: '/login', name: 'login', component: Login, meta: { public: true } },
  { path: '/map', name: 'map', component: MapPage, meta: { requiresAuth: true } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const { isAuthed, verifyToken } = useAuth()
  if (to.meta.public) return true

  // Soft check: if we have a token, optionally verify with server
  if (!isAuthed.value) {
    const ok = await verifyToken()
    if (!ok) return { name: 'login', query: { next: to.fullPath } }
  }
  return true
})

export default router
